import React from 'react';
import { Grid, AuthSection, AuthTitle } from './styles';
import { IPresenterProps } from './types';

const AuthLayoutPresenter: React.FC<IPresenterProps> = ({ title, children }) => {
    return (
        <Grid>
            <AuthSection>
                <AuthTitle>{title}</AuthTitle>
                {children}
            </AuthSection>
        </Grid>
    );
};

export default AuthLayoutPresenter;